import { createContext } from "react"
import { BudgetReference, BudgetSummary, createDefaultState, Dispatch, getSummary, SaveState, Worksheet } from "./budgetCalculatorModel"
import { BudgetStatistics, calculateStatistics } from "./budgetModel"

export type ContextData = {
  worksheet: Worksheet
  summary: BudgetSummary
  statistics: BudgetStatistics
  budgets: BudgetReference[]
  saveWorksheetNow: () => Promise<void>
  dispatch: Dispatch
  saveState: SaveState
  showCongratulations: boolean
  dismissCongratulations: () => void
}

export const defaultBudgetCalculatorContext = (): ContextData => {
  const state = createDefaultState()
  const summary = getSummary(state)
  return {
    worksheet: {
      title: '',
      budgetWorksheetId: '',
      data: state,
      isApplied: false,
      appliedAt: null,
      metadata: {
        createdVia: 'manual'
      }
    },
    summary,
    statistics: calculateStatistics(summary, state.profit),
    budgets: [],
    saveWorksheetNow: () => Promise.resolve(),
    dispatch: () => {},
    saveState: 'SAVED',
    showCongratulations: false,
    dismissCongratulations: () => {}
  }
}

export default createContext<ContextData>(defaultBudgetCalculatorContext())
